import { Component, computed, inject, input } from '@angular/core';
import {
  ControlContainer,
  FormGroup,
  FormGroupDirective,
  ReactiveFormsModule,
} from '@angular/forms';
import { DetailRowComponent } from '@shared/detail-row/detail-row.component';
import { InputText } from 'primeng/inputtext';
import { Konto } from './konto.model';
import { InputNumber } from 'primeng/inputnumber';
import { Select } from 'primeng/select';

@Component({
  selector: 'app-konto',
  imports: [
    ReactiveFormsModule,
    InputText,
    InputNumber,
    Select,
    DetailRowComponent,
  ],
  templateUrl: './konto.component.html',
  styleUrl: './konto.component.css',
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective },
  ],
})
export class KontoComponent {
  konto = input.required<Konto | undefined>();
  editMode = input.required<boolean>();
  formPath = input<string[]>();

  private formGroupDirective = inject(FormGroupDirective);

  getForm = computed(() => {
    let kontoForm: FormGroup | undefined = undefined;
    if (this.formPath()) {
      kontoForm = this.formGroupDirective.form;
      this.formPath()!.forEach(f => {
        kontoForm = kontoForm!.get(f) as FormGroup;
      });
    }
    return kontoForm;
  });

  skyggesaldoOptions = [
    { text: 'Disponibel', value: 'DISPONIBEL' },
    { text: 'Opsparing', value: 'OPSPARING' },
    { text: 'Budget', value: 'BUDGET' },
  ];
}
